import { ServerSessionWatcherService } from '@technocom/core';
import { Producer } from '@technocom/common/platform';
import { AuthenticationDetails } from '@technocom/auth';

export function StartupSessionInitializer(
  watcher: ServerSessionWatcherService,
): Producer<Promise<AuthenticationDetails>> {
  return () =>
    watcher
      .setupWatcher()
      .fetch()
      .catch(error => {
        // suppress during launch
        return null;
      });
}
